import { Platform } from 'react-native';
import iconEntypo from 'react-native-vector-icons/Fonts/Entypo.ttf';
import iconEvilIcons from 'react-native-vector-icons/Fonts/EvilIcons.ttf';
import iconFeather from 'react-native-vector-icons/Fonts/Feather.ttf';
import iconFontAwesome from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
import iconFoundation from 'react-native-vector-icons/Fonts/Foundation.ttf';
import iconIonicons from 'react-native-vector-icons/Fonts/Ionicons.ttf';
import iconMaterialCommunityIcons
  from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
import iconMaterialIcons
  from 'react-native-vector-icons/Fonts/MaterialIcons.ttf';
import iconOcticons from 'react-native-vector-icons/Fonts/Octicons.ttf';
import iconSimpleLineIcons
  from 'react-native-vector-icons/Fonts/SimpleLineIcons.ttf';
import iconZocial from 'react-native-vector-icons/Fonts/Zocial.ttf';

export default class FontUtils {

  static importEntypo = () => {
    FontUtils.importIconFont(iconEntypo, 'Entypo');
  };

  static importEvilIcons = () => {
    FontUtils.importIconFont(iconEvilIcons, 'EvilIcons');
  };

  static importFeather = () => {
    FontUtils.importIconFont(iconFeather, 'Feather');
  };

  static importFontAwesome = () => {
    FontUtils.importIconFont(iconFontAwesome, 'FontAwesome');
  };

  static importFoundation = () => {
    FontUtils.importIconFont(iconFoundation, 'Foundation');
  };

  static importIonicons = () => {
    FontUtils.importIconFont(iconIonicons, 'Ionicons');
  };

  static importMaterialCommunityIcons = () => {
    FontUtils.importIconFont(iconMaterialCommunityIcons,
      'MaterialCommunityIcons');
  };

  static importMaterialIcons = () => {
    FontUtils.importIconFont(iconMaterialIcons, 'MaterialIcons');
  };

  static importOcticons = () => {
    FontUtils.importIconFont(iconOcticons, 'Octicons');
  };

  static importSimpleLineIcons = () => {
    FontUtils.importIconFont(iconSimpleLineIcons, 'SimpleLineIcons');
  };

  static importZocial = () => {
    FontUtils.importIconFont(iconZocial, 'Zocial');
  };

  static importIconFont = (iconFont, fontFamily) => {
    if (Platform.OS !== 'web') {
      return;
    }

    const innerText = `@font-face {
      src: url(${iconFont});
      font-family: ${fontFamily};
    }`;
    for (let childNode of document.head.childNodes) {
      if (childNode.nodeName !== 'STYLE') {
        continue;
      }
      if (childNode.innerText === innerText) {
        // icon font already
        return;
      }
    }

    const style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = innerText;
    } else {
      style.appendChild(document.createTextNode(innerText));
    }
    document.head.appendChild(style);
  };
}



// WEBPACK FOOTER //
// ./src/utils/FontUtils.js